import type { UserRole } from "../types/domain";

const rolePriority: UserRole[] = [
  "super_admin",
  "municipal_admin",
  "mayor",
  "general_secretary",
  "treasury_agent",
  "intake_supervisor",
  "intake_agent",
  "system_admin",
  "news_editor",
  "designer",
  "academic_admin",
  "academic_editor",
  "fleet_operator",
  "student",
  "citizen",
  "department_head",
  "department_agent",
  "information_officer",
  "auditor",
  "security_officer",
  "executive_viewer",
];

export function selectPrimaryRole(roles: UserRole[]): UserRole | null {
  return rolePriority.find((role) => roles.includes(role)) ?? null;
}

export function roleHome(role: UserRole): string {
  if (role === "student") return "/academia/mi-aprendizaje";
  if (role === "academic_admin" || role === "academic_editor") {
    return "/academia/gestion";
  }
  if (role === "citizen") return "/mi";
  if (role === "news_editor" || role === "designer") {
    return "/gestion/contenidos";
  }
  if (role === "treasury_agent") return "/gestion/pagos";
  return "/gestion";
}
